import { useEffect, useState } from 'react';

export function useNetworkStatus(): { online: boolean } {
  const initialOnline = typeof navigator === 'undefined' ? true : navigator.onLine;
  const [online, setOnline] = useState<boolean>(initialOnline);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    globalThis.addEventListener('online', on);
    globalThis.addEventListener('offline', off);
    return () => {
      globalThis.removeEventListener('online', on);
      globalThis.removeEventListener('offline', off);
    };
  }, []);
  return { online };
}
